<div class="grants-page-layout geaui-sidebar-grid geaui-scrollable-table">
  <div class="grants-header flex justify-content-between">
    <div class="gea-font-heading-24">Grants</div>
    <div class="flex gap-2">
      @if (selectedGrants().length > 0) {
        <geaui-button-v3 (click)="deleteSelectedGrants()" preIcon="remove" information="error" type="tertiary">
          Remove selected ({{ selectedGrants().length }})
        </geaui-button-v3>
      }
      <geaui-button-v3 [sending]="fetchingMetadata()" (click)="addGrants()" preIcon="e-add">Add</geaui-button-v3>
    </div>
  </div>
  <div class="grants-table-container">
    <geaui-table-v3
      [tableId]="tableId"
      [columnDefinitions]="grantsColumnDefinition"
      [data]="grants()"
      [totalRecords]="grants().length"
      [selectionMode]="'multiple'"
      [loading]="loadingGrants()"
      [rowsClickable]="true"
      [isLandingPage]="true"
      [noEntriesInfoText]="'No entries available yet'"
      [noEntriesActionIcon]="'_sort'"
      (selectionChange)="onSelectionChange($event)"></geaui-table-v3>
  </div>
</div>
